// TalkRobin: visitors currently on the account's websites, kept live by
// useVisitorMonitor. Powers the Monitoring page, its sidebar count and
// visitor profiles (through the pass).
export const types = {
  SET_SNAPSHOT: 'SET_SNAPSHOT',
  UPSERT_VISITOR: 'UPSERT_VISITOR',
  REMOVE_VISITOR: 'REMOVE_VISITOR',
  SET_CONNECTION: 'SET_CONNECTION',
  SET_PASS: 'SET_PASS',
};

export const state = {
  records: {},
  // Visitors who left recently (vid -> visitor with status "left").
  recent: {},
  // connecting | live | reconnecting | unavailable
  connection: 'connecting',
  // Signed pass for the Insights service: { url, token, expires_at }
  pass: null,
};

export const getters = {
  getVisitors: $state => Object.values($state.records),
  getOnlineCount: $state => Object.keys($state.records).length,
  getConnection: $state => $state.connection,
  getPass: $state => $state.pass,
  getRecentVisitor: $state => vid => $state.recent[vid] || null,
};

const RECENT_FOR_MS = 30 * 60 * 1000;

export const mutations = {
  [types.SET_SNAPSHOT]($state, visitors) {
    $state.records = Object.fromEntries(visitors.map(v => [v.vid, v]));
  },
  [types.UPSERT_VISITOR]($state, visitor) {
    $state.records[visitor.vid] = visitor;
  },
  [types.REMOVE_VISITOR]($state, vid) {
    const visitor = $state.records[vid];
    delete $state.records[vid];
    if (visitor) {
      const now = Date.now();
      $state.recent[vid] = { ...visitor, status: 'left', leftAt: now };
      Object.keys($state.recent).forEach(key => {
        if (now - $state.recent[key].leftAt > RECENT_FOR_MS)
          delete $state.recent[key];
      });
    }
  },
  [types.SET_CONNECTION]($state, connection) {
    $state.connection = connection;
  },
  [types.SET_PASS]($state, pass) {
    $state.pass = pass;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
